// Command Manager - 指令管理器
import { BaseCommand } from './BaseCommand.js';

class CommandManager {
  constructor(stateManager, explorationManager, forbiddenManager) {
    this.stateManager = stateManager;
    this.explorationManager = explorationManager;
    this.forbiddenManager = forbiddenManager;
    this.commands = new Map();
    this.chineseToEnglish = new Map();
  }

  // 注册指令
  registerCommand(command) {
    this.commands.set(command.name, command);
    if (command.chineseName) {
      this.chineseToEnglish.set(command.chineseName, command.name);
    }
  }

  // 执行指令
  executeCommand(input) {
    const args = input.trim().split(/\s+/);
    let cmd = args[0].toLowerCase();
    const arg = args.slice(1).join(' ');

    // 中文命令映射到英文
    if (this.chineseToEnglish.has(cmd)) {
      cmd = this.chineseToEnglish.get(cmd);
    }

    const command = this.commands.get(cmd);
    if (!command) {
      return ['未知命令。点击帮助。'];
    }

    // 检查指令可用性
    if (!command.isAvailable()) {
      return [command.getUnavailableMessage()];
    }

    try {
      return command.execute(arg);
    } catch (error) {
      console.error(`指令 ${cmd} 执行错误:`, error);
      return [`指令执行失败：${error.message}`];
    }
  }

  // 获取可用指令列表
  getAvailableCommands() {
    const available = [];
    for (const [name, command] of this.commands) {
      if (command.isAvailable()) {
        available.push(name);
      }
    }
    return available;
  }

  // 获取指令建议
  getSuggestions(input) {
    if (!input || input.trim() === '') {
      return [];
    }

    const trimmedInput = input.trim().toLowerCase();
    const availableCommands = this.getAvailableCommands();

    // 添加中文命令
    const chineseCommands = [];
    for (const [chineseName, englishName] of this.chineseToEnglish) {
      if (this.commands.get(englishName) && this.commands.get(englishName).isAvailable()) {
        chineseCommands.push(chineseName);
      }
    }

    const allCommands = availableCommands.concat(chineseCommands);

    return allCommands.filter(cmd =>
      cmd.toLowerCase().startsWith(trimmedInput)
    ).slice(0, 10);
  }

  // 检查是否需要自动保存
  shouldAutoSave(cmd) {
    const command = this.commands.get(cmd);
    return command ? command.shouldAutoSave : false;
  }
}

export { CommandManager, BaseCommand };
